import PhoneEditForm from "./PhoneEditForm.component";

export default PhoneEditForm;